(() => {
  if (customElements.get('detropolis-clock-controller')) return;
  class DetropolisClockController extends HTMLElement {
    connectedCallback() {
      this.clock = this.parentElement;
      this.target = Date.parse(this.clock.dataset.deadline);
      this.digits = this.clock.querySelector('.dw-digits');
      this.message = this.clock.querySelector('.dw-expired');
      if (!Number.isFinite(this.target)) return;
      this.update = () => {
        const total = Math.max(0, Math.ceil((this.target - Date.now()) / 1000));
        const values = {
          days: Math.floor(total / 86400),
          hours: Math.floor(total / 3600) % 24,
          minutes: Math.floor(total / 60) % 60,
          seconds: total % 60
        };
        for (const [unit, value] of Object.entries(values)) {
          this.clock.querySelector(`[data-unit="${unit}"]`).textContent = String(value).padStart(2, '0');
        }
        this.digits.hidden = total === 0;
        this.clock.closest('.dw-page')?.querySelectorAll('.dw-form').forEach(form => {
          form.hidden = total === 0;
        });
        if (total === 0) {
          this.message.textContent = this.clock.dataset.expired;
          this.message.hidden = false;
          const link = this.clock.querySelector('.dw-live-link');
          if (link) link.hidden = false;
          clearInterval(this.timer);
        }
      };
      this.update();
      if (this.target > Date.now()) this.timer = setInterval(this.update, 1000);
    }
    disconnectedCallback() { clearInterval(this.timer); }
  }
  customElements.define('detropolis-clock-controller', DetropolisClockController);
  const init = (scope) => {
    scope.querySelectorAll('.dw-clock').forEach(clock => {
      if (!clock.querySelector('detropolis-clock-controller')) {
        const controller = document.createElement('detropolis-clock-controller');
        controller.hidden = true;
        clock.append(controller);
      }
    });
  };
  init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
